import { Flex, Box } from 'reflexbox';
import styled from 'styled-components';

import { CheckmarkIcon, LockIcon } from '@treams/treams-icons';
import { Heading } from '@treams/treams-ui';

import FreshheadsLogo from '../assets/FreshheadsLogo.svg';
import SpotzerDigitalLogo from '../assets/SpotzerDigitalLogo.svg';
import SalonizedLogo from '../assets/SalonizedLogo.png';
import GoodhabitzLogo from '../assets/GoodhabitzLogo.png';
import GreenhouseGroupLogo from '../assets/GreenhouseGroupLogo.png';
import { useTranslation } from 'react-i18next';

const Container = styled(Box)`
	background-color: ${(props) => props.theme.colors.whiteBlue};
`;

const USPList = styled.ul`
	margin: 0;
	padding: 0;
`;

const USPItem = styled.li<{ checkmark?: boolean }>`
	color: ${(props) => props.theme.colors.slateBlue};
	display: flex;
	align-items: center;
	line-height: 2;

	svg {
		width: 24px;
		display: block;

		path {
			${(props) =>
				props.checkmark
					? `fill: ${props.theme.colors.green}`
					: `fill: ${props.theme.colors.antracite}`};
		}
	}
`;

const ClientLogo = styled(Box)`
	img {
		max-width: 100%;
		display: block;
	}
`;

function OnboardingUSPList() {
	const { t } = useTranslation();

	return (
		<>
			<Heading mb={3}>{t('onboarding.sidebar.heading')}</Heading>

			<USPList>
				<USPItem checkmark>
					<Box mr={2}>
						<CheckmarkIcon />
					</Box>
					{t('onboarding.sidebar.freeTrial')}
				</USPItem>
				<USPItem checkmark>
					<Box mr={2}>
						<CheckmarkIcon />
					</Box>
					{t('onboarding.sidebar.noPayment')}
				</USPItem>
				<USPItem checkmark>
					<Box mr={2}>
						<CheckmarkIcon />
					</Box>
					<strong>{t('onboarding.sidebar.fastOnline')}</strong>
				</USPItem>
			</USPList>
			<Box mt={3}>
				<USPList>
					<USPItem>
						<Box mr={2}>
							<LockIcon />
						</Box>
						{t('onboarding.sidebar.gdprCompliant')}
					</USPItem>
				</USPList>
			</Box>
		</>
	);
}

function ClientLogosList() {
	const { t } = useTranslation();

	return (
		<>
			<Heading mt={5} mb={3}>
				{t('onboarding.sidebar.clients')}
			</Heading>

			<Flex alignItems="center" mb={3}>
				<ClientLogo width={40} mr={3}>
					<FreshheadsLogo />
				</ClientLogo>
				<ClientLogo width={110} mr={3}>
					<SpotzerDigitalLogo />
				</ClientLogo>
				<ClientLogo width={120} mr={3}>
					<img src={GreenhouseGroupLogo} alt="" />
				</ClientLogo>
			</Flex>
			<Flex alignItems="center">
				<ClientLogo width={120} mr={3}>
					<img src={SalonizedLogo} alt="" />
				</ClientLogo>
				<ClientLogo width={110} mr={3}>
					<img src={GoodhabitzLogo} alt="" />
				</ClientLogo>
			</Flex>
		</>
	);
}

export function Sidebar() {
	return (
		<Container width={[1, 1, 4 / 12]} pt={[4, 4, 150]} pb={4} px={4} flexGrow={1}>
			<OnboardingUSPList />
			<ClientLogosList />
		</Container>
	);
}
